import { server } from "@std/lib/publicEnv";

export const meta = (id) =>
  fetch(`${server}/api/client/${id}`).then((r) => r.json());

export const aggregate = (id) =>
  fetch(`${server}/api/client/${id}/aggregateData`).then((r) => r.json());

export const videos = (id, type = "all", start = 0, limit = 40) =>
  fetch(
    `${server}/api/content/search/?start=${start}&limit=${
      start + limit
    }&client=${id}&type=${type}`
  ).then((r) => r.json());

export const thumbnails = (id, type = "all", start = 0, limit = 40) =>
  fetch(
    `${server}/api/content/search/?start=${start}&limit=${
      start + limit
    }&client=${id}&type=${type}&thumbnails=true`
  ).then((r) => r.json());
